import { render } from "./ReceiptUpdate.vue?vue&type=template&id=16ec05ac&scoped=true"
import script from "./ReceiptUpdate.vue?vue&type=script&lang=js"
export * from "./ReceiptUpdate.vue?vue&type=script&lang=js"

import "./ReceiptUpdate.vue?vue&type=style&index=0&id=16ec05ac&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ec05ac"]])

export default __exports__